// useHlsAudioActions.js
import { useContext } from "react";
import { HlsAudioActionsContext } from "./HlsAudioContext";
import { HlsAudioStateContext } from "./HlsAudioContext";


/**
 * Custom hook to access HLS Audio state from context.
 * Must be used within a <HlsAudioWrapper>.
 *
 * @returns {import("./HlsAudioContext").HlsActionContextValue}
 * @throws {Error} If used outside of <HlsAudioWrapper>
 */
export function useHlsAudioActions() {
  return useContext(HlsAudioActionsContext);
}

/**
 * Custom hook to access HLS Audio state from context.
 * Must be used within a <HlsAudioWrapper>.
 *
 * @returns {import("./HlsAudioContext").HlsStateContextValue}
 * @throws {Error} If used outside of <HlsAudioWrapper>
 */
export function useHlsAudioState() {
  return useContext(HlsAudioStateContext);
}
